module.exports = __webpack_public_path__ + "img/Illustration.9a3643d2.png";